import { useEffect, useState, useCallback } from "react"
import { svgEditServiceInstance } from "@/services/svg-edit-service";

export const useCurrentlySelectedSvgElements = (onSelectedChanged?: (newSelection: SVGGraphicsElement[]) => void) => {
    // Dummy state that can be set to trigger a rerender for any component that uses this hook.
    const [_, setDummy] = useState<{}>({});

    const doOnSelectedChanged = useCallback(() => {
        setDummy({});
        if (onSelectedChanged) {
            onSelectedChanged(svgEditServiceInstance.selectedElements);
        }
    }, [onSelectedChanged]);

    useEffect(() => {
        svgEditServiceInstance['_subscribedSelectionChangesObservers'].push(doOnSelectedChanged);

        return () => {
            const filtered = svgEditServiceInstance['_subscribedSelectionChangesObservers'].filter((update) => update !== doOnSelectedChanged);
            svgEditServiceInstance['_subscribedSelectionChangesObservers'] = filtered;
        }
    }, []);

    return svgEditServiceInstance.selectedElements;
}